import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Google+ redesigned into Facebook",
  "description": "",
  "published": "2012-04-11T00:00:00.000Z",
  "redirect_from": ["/blog/google-redesigned-into-facebook/swizec/4162"],
  "categories": "Companies, Facebook, Google, Search Engines, Social network, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://google.com",
        "title": "Google"
      }}>{`Google`}</a>{` has turned into one of those `}{`_`}{`"Yeah we're just like `}<a parentName="p" {...{
        "href": "http://facebook.com",
        "title": "Facebook"
      }}>{`Facebook`}</a>{`, but with a cleaner design and without annoying ads. Can you invest half a million dollars mister VC? kthxbai" `}{`_`}{`startups.`}</p>
    <p>{`This is a company making self driving cars for fuck's sake, they should know better!`}</p>
    <p>{`Just look at the screenshots.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/Screen-Shot-2012-04-11-at-11.28.06-PM.png",
        "alt": "New Google+",
        "title": "New Google+"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/04/Screen-Shot-2012-04-11-at-11.27.47-PM.png",
        "alt": "Facebook timeline",
        "title": "Facebook timeline"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://socialtimes.com/the-google-redesign-is-simple-functional-and-very-social-video_b93994"
        }}>{`The Google+ Redesign is Simple, Functional and Very Social `}{`[`}{`Video`}{`]`}</a>{` (socialtimes.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.sociableblog.com/2012/04/11/google-plus-gets-redesign/"
        }}>{`Google+ Gets a Complete Redesign, With a More Customizable Interface`}</a>{` (sociableblog.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.electronista.com/articles/12/04/11/google.reworked.early/"
        }}>{`Google+ gets big redesign for customization, hangout focus`}</a>{` (electronista.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thetechnologycafe.com/google-launches-a-major-redesigned-version-of-google-challenges-facebook-pictures/"
        }}>{`Google Launches A Major Redesigned Version Of Google+ : Challenges Facebook `}{`[`}{`Pictures`}{`]`}</a>{` (thetechnologycafe.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=84ed8b42-97da-436e-b2e3-568f811b9515",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      